var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.items),function(item){return _c('v-tooltip',{key:item.id,attrs:{"disabled":!_vm.isTooLongName(item.name),"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_vm._t("default",null,{"item":item,"on":on,"itemName":_vm.shortenName(item.name)})]}}],null,true)},[_c('span',[_vm._v(_vm._s(item.name))])])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }